<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <h4 class="app-stepper-title">Escolha um veículo para continuar</h4>
    <v-autocomplete
      v-model="formCreate.veiculoTransportadora"
      :items="items"
      :loading="isLoadingSearch"
      :search-input.sync="search"
      hide-no-data
      hide-selected
      item-text="veiculo.placa"
      return-object
      label="Placa"
      :rules="[rules.required]"
      placeholder="Digite a placa do veículo para pesquisar"
      prepend-inner-icon="directions_bus"
      outlined
      clearable
      color="primary"
    />
    <v-card-actions class="mr-0 ml-0 pt-0">
      <v-spacer />
      <v-btn
        v-if="formCreate.veiculoTransportadora"
        depressed
        type="submit"
        color="primary"
        class="mt-1"
      >
        Continuar
      </v-btn>
    </v-card-actions>
    <section v-if="form.isLoading" class="loading">
      <v-progress-circular indeterminate color="primary" />
      <span>Enviando informações ...</span>
    </section>
  </v-form>
</template>

<script>
import VeiculoTransportadoraService from "@/services/sit-pedidos/veiculo-transportadora.service";

// Vuex Store - Sit Pedidos (mapping actions and states)
import { mapState, mapActions, mapMutations } from "vuex";
import pedidoService from "@/services/sit-pedidos/pedido.service";
const actions = mapActions("sitPedidos", [
  "setFormPedido",
  "setFormIsLoading",
  "setFormStep",
]);
const state = mapState("sitPedidos", ["form"]);

import { TipoDocumentoEnum } from "@/store/modules/renovacao-crlv";

export default {
  name: "VeiculosForm",
  data: () => ({
    isLoadingSearch: false,
    search: null,
    items: [],
    formCreate: {
      tipoPedido: "RENOVACAO_REGISTRO_VEICULO", // Renovação do Registro de Veículo
      veiculoTransportadora: null,
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
    },

  }),
  computed: {
    ...state,
  },
  watch: {
    search(val) {
      this.loadVeiculos(val);
    },
  },
  mounted() {
    this.loadVeiculos();
  },
  methods: {
    ...actions,
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        const {
          tipoPedido,
          veiculoTransportadora: { id },
        } = this.formCreate;
        this.setFormIsLoading(true);

        pedidoService
          .createPedido({ tipoPedido, veiculoTransportadora: { id } })
          .subscribe(
            (res) => {
              this.setFormIsLoading(false);
              this.setFormPedido(res);
              this.setFormStep(2);
            },
            (err) => {
              this.setFormIsLoading(false);
            }
          );
      }
    },
    loadVeiculos(value = "") {
      if (this.items.length > 0) return;

      if (this.isLoadingSearch) return;

      this.isLoadingSearch = true;

      const query = {
        page: 0,
        size: 10000,
      };

      VeiculoTransportadoraService.list(query).subscribe(
        ({ content }) => {
          this.items = content;
          this.isLoadingSearch = false;
        },
        (err) => {
          this.isLoadingSearch = false;
        }
      );
    },
  },
};
</script>
